import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.fontecor,
  },
}));

export default function Title(props) {
  const classes = useStyles();
  return (
    <Typography variant="h5" className={classes.title} gutterBottom>
      {props.children}
    </Typography>
  );
}
